export enum CarouselType {
    BRANDS = 'brands',
    CHARACTER = 'characterCarousel',
    SHOW_MOVIE_HYBRID = 'showMovieHybrid',
    KEEP_WATCHING = 'keepWatching',
    PROMINENT = 'prominent',
    PROMOTION = 'promotion',
    SPOTLIGHT = 'spotlight',
    SPOTLIGHT_MARQUEE = 'spotlight_marquee',
    SPOTLIGHT_MARQUEE_169 = 'spotlight_marquee_16x9',
    DISPLAY_AD_BANNER = 'displayAdBanner',
    POSTER_GRID = 'grid',
    VIDEO_CONFIG = 'videoConfig',
    RECOMMENDATION = 'recommendation',
    UNIVERSAL_CONTENT = 'universalContent',
}
